import { SVGProps, Ref, forwardRef } from 'react';

export const MaxGrayscaleSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.236 22.88c-2.159 0-3.162-.315-4.906-1.575-1.103 1.417-4.596 2.524-4.749.63 0-1.422-.315-2.624-.672-3.936C1.483 16.382 1 14.582 1 11.974 1 5.744 6.117 1.058 12.179 1.058c6.067 0 10.82 4.918 10.82 10.974a10.8 10.8 0 0 1-3.135 7.648 10.83 10.83 0 0 1-7.628 3.2m.09-16.437c-2.953-.153-5.253 1.889-5.763 5.09-.42 2.65.326 5.878.961 6.046.305.073 1.072-.546 1.55-1.023.79.545 1.71.873 2.669.95 1.47.07 2.91-.438 4.009-1.417a5.61 5.61 0 0 0 1.869-3.816 5.61 5.61 0 0 0-1.456-3.994 5.62 5.62 0 0 0-3.84-1.831z"
                fill="#919191"
            />
        </g>
    </svg>
));
MaxGrayscaleSize24Glyph.displayName = 'MaxGrayscaleSize24Glyph';
